const React = require("react");
const T = React.PropTypes;
const _ = require("lodash");

const Config = require("../Config.js");
const HistoricalFile = require("../types/HistoricalFile.js");
const UploadHistoryActionCreators = require("../actionCreators/UploadHistoryActionCreators.js");

const TitledMessage = require("./TitledMessage.jsx");
const HttpResponse = require("./HttpResponse.jsx");
const Spinner = require("./Spinner.jsx");
const HistoryList = require("./HistoryList.jsx");
const HistoryFooter = require("./HistoryFooter.jsx");

const styles = {
    Outer: {
        textAlign: "center",
        color: "#555",
        paddingBottom: 100
    },
    SpinnerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40%"
    },
    List: {
        padding: 20,
        width: "60%",
        maxWidth: 720,
        margin: "auto"
    },
    Footer: {
        marginTop: 50
    }
};

const History = React.createClass({
    propTypes: {
        style: T.object,
        History: T.shape({
            HasLoaded: T.bool.isRequired,
            IsLoading: T.bool.isRequired,
            Data: T.arrayOf(HistoricalFile.Type),
            Error: T.object
        }),
        AncientHistory: T.shape({
            HasLoaded: T.bool.isRequired,
            IsLoading: T.bool.isRequired,
            Data: T.arrayOf(HistoricalFile.Type),
            Error: T.object
        })
    },
    componentDidMount() {
        UploadHistoryActionCreators.GetRecent();
    },
    getDefaultProps() {
        return {
            style: {}
        }
    },
    render() {
        let children = null;

        if (this.props.History.Error) {
            const response = this.props.History.Error.response;

            children = (
                <TitledMessage Title="We got problems."
                               Subtitle="Kindly try reloading this page.  If you keep getting this error, please contact support with the following information:">
                    <HttpResponse Response={response} style={{ margin: "30px 20%" }} />
                </TitledMessage>);
        }
        else if (!this.props.History.HasLoaded) {
            children = (<div style={styles.SpinnerBox}>
                <Spinner Message="Loading..." WithTimer={true} Large={true } />
            </div>);
        }
        else {
            children = (<div style={styles.List }>
                <HistoryList HistoryItems={this.props.History.Data} />
                <HistoryFooter style={styles.Footer} 
                               AncientHistory={this.props.AncientHistory} />
            </div>);
        }

        const style = Object.assign({}, styles.Outer, this.props.style);

        return (<article style={style}>
            {children}
        </article>);
    }
});

module.exports = History;



// WEBPACK FOOTER //
// ./src/components/History.jsx